export default {
  text: '#202020',
  primary: '#7997a8',
  secondary: '#9d7140',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#484848'
}
